// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import { Currency, type CurrencyWireFormat, NewCurrency } from '../Currency/Currency';
import Enums from '../Enums';

export class QuoteRevisionProduct {
  readonly productId: string;
  readonly productName: string;
  readonly kind: Enums.QuoteProductKind;
  readonly price: Currency;

  constructor(data: { [key: string]: any } = {}) {
    this.productId = data.productId === undefined ? NIL_UUID : data.productId;
    this.productName = data.productName === undefined ? '' : data.productName;
    this.kind = data.kind === undefined ? Enums.QuoteProductKind.Primary : data.kind;
    this.price = NewCurrency(data.price);
  }

  static zero(): QuoteRevisionProduct {
    const zeroValues: ExcludeMethodsDeep<QuoteRevisionProduct> = {
      productId: NIL_UUID,
      productName: '',
      kind: Enums.QuoteProductKind.Primary,
      price: Currency.zero(),
    };
    return new QuoteRevisionProduct(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type QuoteRevisionProductWireFormat = {
  productId: string;
  productName: string;
  kind: string;
  price: CurrencyWireFormat;
};

type NewQuoteRevisionProductProps = PartialDeep<QuoteRevisionProduct, { recurseIntoArrays: true }>;
export const NewQuoteRevisionProduct: (
  props: NewQuoteRevisionProductProps,
) => QuoteRevisionProduct = (props) => new QuoteRevisionProduct(props);

type NewQuoteRevisionProductFromWireFormatProps = PartialDeep<
  QuoteRevisionProductWireFormat,
  { recurseIntoArrays: true }
>;
export const NewQuoteRevisionProductFromWireFormat: (
  props: NewQuoteRevisionProductFromWireFormatProps,
) => QuoteRevisionProduct = (props) => new QuoteRevisionProduct(props);
